var render = function render(){
  var _vm$error, _vm$error$validationM, _vm$error2, _vm$error2$validation, _vm$error3, _vm$error3$validation;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('password.header')))]), _vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key)) + " ")]) : _vm._e(), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [!_vm.isAdmin ? _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "old-password",
      "label": _vm.$t('password.form.old-password'),
      "validation-messages": (_vm$error = _vm.error) === null || _vm$error === void 0 ? void 0 : (_vm$error$validationM = _vm$error.validationMessages) === null || _vm$error$validationM === void 0 ? void 0 : _vm$error$validationM.oldPassword,
      "type": "password",
      "state": _vm.getStateWithoutSubmit('oldPassword'),
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.oldPassword.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('password.form.old-password')
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 4030063875),
    model: {
      value: _vm.$v.formData.oldPassword.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.oldPassword, "$model", $$v);
      },
      expression: "$v.formData.oldPassword.$model"
    }
  })], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "password",
      "label": _vm.$t('password.form.password'),
      "validation-messages": (_vm$error2 = _vm.error) === null || _vm$error2 === void 0 ? void 0 : (_vm$error2$validation = _vm$error2.validationMessages) === null || _vm$error2$validation === void 0 ? void 0 : _vm$error2$validation.password,
      "type": "password",
      "state": _vm.getStateWithoutSubmit('password'),
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.password.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('password.form.password')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('password.form.password'),
          max: _vm.$v.formData.password.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.minLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.min-length', {
          field: _vm.$t('password.form.password'),
          min: _vm.$v.formData.password.$params.minLength.min
        })) + " ")]) : _vm._e(), !_vm.$v.formData.password.uppercase ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.uppercase')) + " ")]) : _vm._e(), !_vm.$v.formData.password.digit ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.digit')) + " ")]) : _vm._e(), !_vm.$v.formData.password.special ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.special')) + " ")]) : _vm._e(), !_vm.$v.formData.password.notSameAs ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.not-same-as')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.password.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.password, "$model", $$v);
      },
      expression: "$v.formData.password.$model"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "6",
      "sm": "12"
    }
  }, [_c('form-input', {
    attrs: {
      "id": "password-again",
      "label": _vm.$t('password.form.password-again'),
      "validation-messages": (_vm$error3 = _vm.error) === null || _vm$error3 === void 0 ? void 0 : (_vm$error3$validation = _vm$error3.validationMessages) === null || _vm$error3$validation === void 0 ? void 0 : _vm$error3$validation.passwordAgain,
      "type": "password",
      "state": _vm.getStateWithoutSubmit('passwordAgain'),
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.passwordAgain.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('password.form.password-again')
        })) + " ")]) : _vm._e(), !_vm.$v.formData.passwordAgain.sameAs ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.password.same-as')) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.$v.formData.passwordAgain.$model,
      callback: function ($$v) {
        _vm.$set(_vm.$v.formData.passwordAgain, "$model", $$v);
      },
      expression: "$v.formData.passwordAgain.$model"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "auto",
      "sm": "12"
    }
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": this.$v.$invalid
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('password.button.submit')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }